import { render } from "./GamesList.vue?vue&type=template&id=3c2a4474"
import script from "./GamesList.vue?vue&type=script&lang=js"
export * from "./GamesList.vue?vue&type=script&lang=js"

import "./GamesList.vue?vue&type=style&index=0&id=3c2a4474&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__